<template>
  <div class="content">
    <span>Ông/bà</span>
    <span class="highlight font-weight__bold"> {{ fromActorFullName }} </span>
    <span>đã</span>
    <span class="highlight-action"> {{ action }} </span>
    <span> bài thảo luận </span>
    <span class="event">"{{ taskTitle }}"</span>
  </div>
</template>

<script>
import constants from "../../constants";

export default {
  name: "notification-item-cv",
  props: ["vbNotificationView"],
  data() {
    return {
      fromActorFullName: null,
      action: null,
      taskTitle: null,
      dataJson: null,
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.dataJson = JSON.parse(this.vbNotificationView.dataJson);
      let action;
      switch (this.vbNotificationView.messageType) {
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.TAG_COMMENT:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.REPLY_COMMENT:
          action = "Nhắc đến bạn trong";
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.APPROVE_DISCUSS:
          action = "Phê duyệt";
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.DECLINE_DISCUSS:
          action = "Từ chối";
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.DELETE_DISCUSS:
          action = "Xóa";
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.SEND_APPROVE_DISCUSS:
          action = "Yêu cầu phê duyệt";
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.REPORT_COMMENT:
          action = "Báo cáo bình luận";
          break;
        default:
          action = "";
          break;
      }
      this.fromActorFullName = this.vbNotificationView.fromUserName || "-";
      this.action = action;
      this.taskTitle = this.dataJson.discuss.topic;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/header/notification-item-discuss.vue